import type { LinkedAccount } from "@store/linkedAccountSlice";
import { getAccountDisplay } from "../accountDisplay";
import { getPlatformConfig } from "../platformConfig";
import { LinkedAccountCardActions } from "./LinkedAccountCardActions";
import { LinkedAccountCardAvatar } from "./LinkedAccountCardAvatar";
import { LinkedAccountCardCornerBadge } from "./LinkedAccountCardCornerBadge";
import { LinkedAccountCardInfo } from "./LinkedAccountCardInfo";

interface LinkedAccountCardProps {
  account: LinkedAccount;
}

export const LinkedAccountCard = ({ account }: LinkedAccountCardProps) => {
  const expired = account.expired === true;
  const platform = account.platform ?? "TIKTOK";
  const { features } = getPlatformConfig(platform);
  const display = getAccountDisplay(account);

  return (
    <div className="group relative min-w-0 rounded-[8px] bg-kds-bg-soft px-[16px] pb-[16px] pt-[28px]">
      {features.cornerBadge && display.cornerBadgeLabel ? (
        <LinkedAccountCardCornerBadge label={display.cornerBadgeLabel} />
      ) : null}
      <div className={`flex gap-[16px] ${expired ? "items-start" : "items-center"}`}>
        <LinkedAccountCardAvatar
          imageUrl={account.accountImage}
          name={account.accountName}
          useStorePlaceholder={display.useStorePlaceholder}
        />
        <LinkedAccountCardInfo
          accountName={account.accountName}
          expired={expired}
          display={display}
          region={account.region}
        />
        <LinkedAccountCardActions account={account} expired={expired} />
      </div>
    </div>
  );
};
